// HeroVaultVideo — plays the treasure-vault hero video ONCE per browser
// session. On subsequent loads in the same session the video pauses on
// its last frame instead of looping or replaying.

import { useRef } from "react";

const KEY = "hero_vault_video_played_v1";
const SRC =
  "https://customer-assets.emergentagent.com/job_3c3abc73-f98e-4833-bdb2-9908042a6faa/artifacts/ofg1xmyq_Treasure_emerging_from_vault_202606091741.mp4";

function alreadyPlayedInSession() {
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch (_) {
    return false;
  }
}

export default function HeroVaultVideo() {
  const ref = useRef(null);
  // Read once at render time — no effect needed.
  const alreadyPlayed = alreadyPlayedInSession();

  function handleEnded() {
    try { sessionStorage.setItem(KEY, "1"); } catch (_) { /* ignore */ }
    const v = ref.current;
    if (v) {
      v.pause();
      v.currentTime = Math.max(0, (v.duration || 0) - 0.05);
    }
  }

  function handleLoadedMetadata() {
    const v = ref.current;
    if (!v) return;
    if (alreadyPlayed) {
      v.pause();
      v.currentTime = Math.max(0, (v.duration || 0) - 0.05);
    }
  }

  return (
    <video
      ref={ref}
      src={SRC}
      autoPlay={!alreadyPlayed}
      muted
      playsInline
      preload="auto"
      onEnded={handleEnded}
      onLoadedMetadata={handleLoadedMetadata}
      className="w-full h-auto rounded-2xl shadow-2xl"
      style={{ aspectRatio: "1 / 1", objectFit: "cover", background: "#050510" }}
      data-testid="hero-vault-video"
    />
  );
}
